if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'teseu:recently-viewed';
      }

      connectedCallback() {
        const current = this.dataset.currentHandle;
        const handles = this.read().filter((h) => h !== current);

        if (current) this.write([current, ...handles].slice(0, 20));

        if (!handles.length) return;
        this.render(handles.slice(0, Number(this.dataset.limit || 4)));
      }

      read() {
        try {
          const raw = localStorage.getItem(this.storageKey);
          const list = raw ? JSON.parse(raw) : [];
          return Array.isArray(list) ? list : [];
        } catch (e) {
          return [];
        }
      }

      write(list) {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(list));
        } catch (e) {
          /* armazenamento indisponível */
        }
      }

      async render(handles) {
        const query = handles.map((h) => `handle:${h}`).join(' OR ');
        const url = `${this.dataset.searchUrl}?type=product&q=${encodeURIComponent(query)}&section_id=${this.dataset.sectionId}`;

        try {
          const response = await fetch(url);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = [...html.querySelectorAll('[data-grid] > [data-handle]')];
          if (!items.length) return;

          items.sort((a, b) => handles.indexOf(a.dataset.handle) - handles.indexOf(b.dataset.handle));

          const grid = this.querySelector('[data-grid]');
          grid.replaceChildren(...items);
          this.hidden = false;
        } catch (e) {
          /* falha silenciosa: a section simplesmente não aparece */
        }
      }
    }
  );
}
